// Helpers for crypto portfolio assets (asset_type "crypto" with
// a crypto_holdings array of {symbol, units, buy_price_usd}).

/**
 * Extract the USD price for a symbol from the cached /crypto-prices rows
 * ({symbol, payload: {symbols: [{last: "64480.01"}]}}). Returns null when
 * the coin isn't cached yet (the backend fetches it on save).
 */
export function cryptoPriceUSD(cryptoPrices, symbol) {
  if (!symbol) return null;
  const row = (cryptoPrices || []).find(
    (r) => r.symbol?.toUpperCase() === symbol.toUpperCase()
  );
  const entry = row?.payload?.symbols?.[0] ?? row?.payload;
  const last = parseFloat(entry?.last);
  return Number.isFinite(last) && last > 0 ? last : null;
}

/** "0.10034925" → trimmed display string (max 8 decimals, no trailing zeros). */
export function formatUnits(units) {
  const n = Number(units) || 0;
  return n.toFixed(8).replace(/\.?0+$/, "");
}

/** "0.2 BTC · 2.0012 ETH · 12.5 SOL" one-line summary of a portfolio. */
export function holdingsSummary(asset) {
  return (asset?.crypto_holdings || [])
    .map((h) => `${formatUnits(h.units)} ${h.symbol}`)
    .join(" · ");
}

/**
 * Aggregate % gain of a portfolio vs. its buy prices, using cached market
 * prices. Only holdings with both a buy price and a cached price count;
 * returns null when none qualify.
 */
export function portfolioGainPercent(asset, cryptoPrices) {
  let invested = 0;
  let current = 0;
  for (const h of asset?.crypto_holdings || []) {
    const buy = Number(h.buy_price_usd);
    const price = cryptoPriceUSD(cryptoPrices, h.symbol);
    if (!(h.units > 0) || !(buy > 0) || !price) continue;
    invested += h.units * buy;
    current += h.units * price;
  }
  if (!invested) return null;
  return ((current - invested) / invested) * 100;
}
